<template>
  <div class="flex flex-col gap-4">
    <div class="flex items-center justify-between">
      <!--tabbar-->
      <slot />
      <!--search panel-->
      <div class="flex items-center gap-2">
        <div class="relative">
          <el-input
            placeholder="Search..."
            prefix-icon="el-icon-search"
            class="w-[250px]"
            clearable
            v-model="searchText"
          />
        </div>
        <el-popover
          placement="bottom"
          trigger="click"
          width="320"
          v-model="filterPanelVisible"
        >
          <button
            slot="reference"
            class="ring-offset-background focus-visible:outline-hidden focus-visible:ring-ring inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 border-input bg-background hover:bg-accent hover:text-accent-foreground border h-10 w-10"
            type="button"
            aria-haspopup="dialog"
            aria-expanded="false"
            aria-controls="radix-_r_1t_"
            data-state="closed"
          >
            <i class="icon-funnel h-4 w-4" />
          </button>
          <ETagFilterPanel @apply="handleApply" />
        </el-popover>
      </div>
    </div>
    <div class="flex-1 overflow-hidden relative">
      <el-scrollbar class="absolute inset-0 scrollbar">
        <!--skeleton screen-->
        <div v-if="isLoading">
          <div
            class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-2"
          >
            <div
              v-for="n of 6"
              :key="n"
              class="rounded-lg border bg-card text-card-foreground shadow-2xs animate-pulse"
              style="min-height: 340px"
            >
              <div class="flex flex-col space-y-1.5 p-4">
                <div class="flex justify-between items-start">
                  <div>
                    <div class="h-5 w-32 bg-gray-200 rounded mb-2"></div>
                    <div class="h-4 w-24 bg-gray-200 rounded mb-1"></div>
                    <div class="h-3 w-20 bg-gray-200 rounded"></div>
                  </div>
                  <div class="h-10 w-10 bg-gray-200 rounded-full"></div>
                </div>
              </div>
              <div class="p-4 pt-0">
                <div
                  class="bg-gray-200 rounded-md mb-4 overflow-hidden relative"
                  style="height: 120px"
                ></div>
                <div class="space-y-4">
                  <div>
                    <div class="h-4 w-24 bg-gray-200 rounded mb-2"></div>
                    <div class="flex items-center gap-3">
                      <div class="w-12 h-12 bg-gray-200 rounded-md"></div>
                      <div>
                        <div class="h-4 w-20 bg-gray-200 rounded mb-1"></div>
                        <div class="h-3 w-16 bg-gray-200 rounded"></div>
                      </div>
                    </div>
                  </div>
                  <div class="space-y-2">
                    <div class="flex justify-between text-sm">
                      <div class="h-3 w-16 bg-gray-200 rounded"></div>
                      <div class="h-3 w-10 bg-gray-200 rounded"></div>
                    </div>
                    <div class="flex justify-between text-sm">
                      <div class="h-3 w-16 bg-gray-200 rounded"></div>
                      <div class="h-3 w-10 bg-gray-200 rounded"></div>
                    </div>
                    <div class="flex justify-between text-sm">
                      <div class="h-3 w-16 bg-gray-200 rounded"></div>
                      <div class="h-3 w-10 bg-gray-200 rounded"></div>
                    </div>
                    <div class="flex justify-between text-sm">
                      <div class="h-3 w-16 bg-gray-200 rounded"></div>
                      <div class="h-3 w-10 bg-gray-200 rounded"></div>
                    </div>
                    <div class="flex justify-between text-sm">
                      <div class="h-3 w-16 bg-gray-200 rounded"></div>
                      <div class="h-3 w-10 bg-gray-200 rounded"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex items-center p-4 pt-0">
                <div class="w-full flex justify-between">
                  <div class="h-8 w-24 bg-gray-200 rounded"></div>
                  <div class="h-8 w-24 bg-gray-200 rounded"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--grid items-->
        <div
          v-else
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          <div
            v-for="display in displays"
            :key="
              display.esl_code ||
              display.product_code ||
              display.ap_code ||
              display.esl_version
            "
            class="rounded-lg border bg-card text-card-foreground shadow-2xs"
            data-v0-t="card"
          >
            <div class="flex flex-col space-y-1.5 p-4">
              <div class="flex flex-col">
                <div>
                  <h3
                    class="flex flex-row justify-between font-semibold tracking-tight text-lg"
                  >
                    <span class="flex flex-row gap-2">
                      <span>ESL Tag</span>
                      <span>:</span>
                      <span>{{ display.esl_code }}</span>
                    </span>
                    <span class="relative">
                      <el-popover
                        placement="bottom-end"
                        trigger="click"
                        :visible="menuOpen"
                        @show="
                          menuOpen = true;
                          menuAnchor = display;
                        "
                        @hide="
                          menuOpen = false;
                          menuAnchor = null;
                        "
                        popper-class="min-w-[8rem] p-0"
                      >
                        <template #reference>
                          <button
                            @click="toggleMenu(display)"
                            class="ring-offset-background focus-visible:outline-hidden focus-visible:ring-ring inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-accent hover:text-accent-foreground h-10 w-10"
                            type="button"
                            aria-haspopup="menu"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-ellipsis-vertical h-4 w-4"
                            >
                              <circle cx="12" cy="12" r="1"></circle>
                              <circle cx="12" cy="5" r="1"></circle>
                              <circle cx="12" cy="19" r="1"></circle>
                            </svg>
                          </button>
                        </template>
                        <div class="flex flex-col min-w-[8rem]">
                          <div class="flex flex-col py-1">
                            <div
                              class="flex items-center gap-2 px-2 py-1.5 rounded-sm text-sm cursor-pointer hover:bg-accent hover:text-accent-foreground"
                              @click="onViewStatus(display)"
                            >
                              <i class="el-icon-info mr-2" />
                              View Status
                            </div>
                            <div
                              class="flex items-center gap-2 px-2 py-1.5 rounded-sm text-sm cursor-pointer hover:bg-accent hover:text-accent-foreground"
                              @click="handleSchedule(display)"
                              role="menuitem"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-calendar h-4 w-4 mr-2"
                              >
                                <path d="M8 2v4"></path>
                                <path d="M16 2v4"></path>
                                <rect
                                  width="18"
                                  height="18"
                                  x="3"
                                  y="4"
                                  rx="2"
                                ></rect>
                                <path d="M3 10h18"></path>
                              </svg>
                              Manage Schedule
                            </div>
                            <div
                              class="flex items-center gap-2 px-2 py-1.5 rounded-sm text-sm cursor-pointer hover:bg-accent hover:text-accent-foreground"
                              @click="handleEditDisplay(display)"
                              role="menuitem"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-square-pen h-4 w-4 mr-2"
                              >
                                <path
                                  d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                                ></path>
                                <path
                                  d="M18.375 2.625a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4Z"
                                ></path>
                              </svg>
                              Edit Display
                            </div>
                            <div class="bg-gray-500 my-1 h-px"></div>
                            <div
                              class="flex items-center gap-2 px-2 py-1.5 rounded-sm text-sm cursor-pointer hover:bg-accent hover:text-accent-foreground"
                              @click="handleViewFullScreen(display)"
                              role="menuitem"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-external-link h-4 w-4 mr-2"
                              >
                                <path d="M15 3h6v6"></path>
                                <path d="M10 14 21 3"></path>
                                <path
                                  d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                                ></path>
                              </svg>
                              View Full Screen
                            </div>
                          </div>
                          <div class="bg-gray-500 my-1 h-px"></div>
                          <div
                            class="flex items-center gap-2 px-2 py-1.5 rounded-sm text-sm cursor-pointer text-red-600 hover:bg-destructive/10 hover:text-destructive"
                            @click="handleDeleteDisplay(display)"
                            role="menuitem"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-trash h-4 w-4 mr-2"
                            >
                              <path d="M3 6h18"></path>
                              <path
                                d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"
                              ></path>
                              <path
                                d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"
                              ></path>
                            </svg>
                            Delete
                          </div>
                        </div>
                      </el-popover>
                    </span>
                  </h3>

                  <div
                    class="flex flex-row w-full items-center mt-1 text-xs text-muted-foreground justify-between"
                  >
                    <p class="text-sm text-muted-foreground">
                      {{ getDisplayDescription(display) }}
                    </p>
                    <span
                      v-if="display.action != 0"
                      class="text-yellow-500 flex gap-1"
                    >
                      <span>Action Code:</span>
                      <span>{{ display.action }}</span>
                      <span>Action From:</span>
                      <span>{{ display.action_from }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-4 pt-0">
              <div class="bg-muted rounded-md mb-4 overflow-hidden relative">
                <AspectRatio :aspect-ratio="'16:9'">
                  <SmartImage
                    :alt="`${getDisplayName(display)} preview`"
                    class="w-full h-full object-cover"
                    :src="getDisplayImageUrl(display)"
                  />
                </AspectRatio>
              </div>
              <div class="space-y-4">
                <div>
                  <h4 class="text-sm font-semibold mb-2">Current Content:</h4>
                  <div class="flex items-center gap-3">
                    <div class="w-12 h-12 bg-muted rounded-md overflow-hidden">
                      <SmartImage
                        :alt="getProductName(display)"
                        class="w-full h-full object-cover"
                        :src="getProductImage(display)"
                      />
                    </div>
                    <div>
                      <p class="text-lg font-bold">
                        {{ getProductName(display) }}
                      </p>
                      <div class="flex items-center gap-2">
                        <span class="text-sm font-medium">
                          {{ getProductPrice(display) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="space-y-2">
                  <div class="flex flex-row justify-between items-center">
                    <span class="text-sm">Status:</span>
                    <el-tag
                      :type="display.online == 1 ? 'success' : 'danger'"
                      disable-transitions
                    >
                      {{ display.online == 1 ? "Online" : "Offline" }}
                    </el-tag>
                  </div>
                  <div class="flex justify-between text-sm">
                    <span class="text-muted-foreground">Battery:</span>
                    <div class="flex items-center gap-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        :class="[
                          'lucide lucide-battery h-4 w-4',
                          getBatteryColor(display),
                        ]"
                      >
                        <rect
                          width="16"
                          height="10"
                          x="2"
                          y="7"
                          rx="2"
                          ry="2"
                        ></rect>
                        <line x1="22" x2="22" y1="11" y2="13"></line>
                      </svg>
                      <span>{{ getBatteryPercent(display) }}</span>
                    </div>
                  </div>
                  <div class="flex justify-between text-sm">
                    <span class="text-muted-foreground">Signal:</span>
                    <div class="flex items-center gap-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        :class="[
                          'lucide lucide-wifi h-4 w-4',
                          getSignalColor(display),
                        ]"
                      >
                        <path d="M12 20h.01"></path>
                        <path d="M2 8.82a15 15 0 0 1 20 0"></path>
                        <path d="M5 12.859a10 10 0 0 1 14 0"></path>
                        <path d="M8.5 16.429a5 5 0 0 1 7 0"></path>
                      </svg>
                      <span>{{ getSignalStrength(display) }}</span>
                    </div>
                  </div>
                  <div class="flex justify-between text-sm">
                    <span class="text-muted-foreground">Template:</span>
                    <span>{{ display.esltemplate_id || "Default" }}</span>
                  </div>
                  <div class="flex justify-between text-sm">
                    <span class="text-muted-foreground">Last Sync:</span>
                    <span>{{
                      formatTimestamp(
                        display.refreshed_at ||
                          display.updated_at ||
                          display.retrieved_at
                      )
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex items-center p-4 pt-0">
              <div class="w-full flex justify-between">
                <el-button
                  icon="el-icon-edit-outline"
                  @click="handleEditProduct(display)"
                >
                  Update Price
                </el-button>
                <span></span>
                <el-button
                  @click="handleSchedule(display)"
                  type="primary"
                  icon="el-icon-date"
                >
                  Schedule
                </el-button>
              </div>
            </div>
          </div>
          <div
            v-if="!isLoading && !displays.length"
            class="col-span-full flex flex-col items-center justify-center py-10 text-center text-sm text-muted-foreground"
          >
            No displays found.
          </div>
        </div>
      </el-scrollbar>
    </div>
    <div class="flex mt-4 justify-end">
      <el-pagination
        @size-change="(val) => tableCtrl.setPageSize(val)"
        @current-change="(val) => tableCtrl.setCurrentPage(val)"
        :current-page="tableCtrl?.state?.pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="tableCtrl?.state?.pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableCtrl?.state?.pagination.total"
      />
    </div>
  </div>
</template>

<script>
import { TableController } from "@/controllers/TableController";
import { getEslTags, getEslProducts, downloadFile } from "@/api";
import AspectRatio from "@/components/AspectRatio.vue";
import ETagFilterPanel from "./ETagFilterPanel.vue";
import SmartImage from "@/components/SmartImage.vue";

export default {
  name: "DisplaysList",
  components: {
    AspectRatio,
    ETagFilterPanel,
    SmartImage,
  },
  props: {
    searchText: {
      type: String,
      default: "",
    },
    queryParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tableCtrl: null,
      menuOpen: false,
      menuAnchor: null,
      filterPanelVisible: false,
      productsMap: {},
      productsLoaded: false,
    };
  },
  computed: {
    displays() {
      const rows = this.tableCtrl?.state.tableData ?? [];
      return this.applySearchFilter(rows);
    },
    isLoading() {
      return this.tableCtrl?.state?.loading ?? true;
    },
  },
  watch: {
    searchText() {
      if (!this.tableCtrl) {
        return;
      }
      this.tableCtrl.state.pagination.page = this.tableCtrl.pageBase;
      this.syncQueryParameters();
    },
    queryParams: {
      deep: true,
      handler() {
        this.syncQueryParameters();
      },
    },
  },
  async mounted() {
    const me = this;
    await me.loadAllProducts();
    me.initTableController();
  },
  methods: {
    initTableController() {
      const me = this;
      const initialQuery = me.buildQueryParameters();
      me.tableCtrl = new TableController({
        loadMethod: me.fetchDisplays,
        pageSize: 12,
        isClientPaged: false,
        keyField: "esl_code",
        pageField: "f1",
        pageSizeField: "f2",
        pageBase: 1,
        totalField: "totalCount",
        queryParameters: initialQuery,
      });
    },
    async loadAllProducts() {
      try {
        const res = await getEslProducts({ f1: 1, f2: 9999 });
        let list = [];
        if (Array.isArray(res)) list = res;
        else if (Array.isArray(res?.list)) list = res.list;
        else if (Array.isArray(res?.data?.list)) list = res.data.list;
        this.productsMap = {};
        list.forEach((p) => {
          if (p && p.product_code) {
            this.productsMap[String(p.product_code)] = p;
          }
        });
        this.productsLoaded = true;
      } catch (e) {
        this.productsMap = {};
        this.productsLoaded = true;
      }
    },
    getProductName(display = {}) {
      const p =
        this.productsMap && display.product_code
          ? this.productsMap[String(display.product_code)]
          : null;
      return (
        p?.product_name ||
        display.pn ||
        display.product_code ||
        "Product Content"
      );
    },
    getProductImage(display = {}) {
      const p =
        this.productsMap && display.product_code
          ? this.productsMap[String(display.product_code)]
          : null;
      const img = p?.product_image;
      if (img) {
        if (/^https:/.test(img)) {
          return img;
        } else {
          const imageName = img.split("/").pop().split("?")[0];
          return downloadFile(
            `${process.env.VUE_APP_API_URL_BASE}/fission/e-tag/upload/images/000/product_image/${imageName}`
          );
        }
      }
      return "/placeholder.svg?height=60&width=60";
    },
    async fetchDisplays(params = {}) {
      try {
        const response = await getEslTags(params);
        const list = this.extractEslList(response);
        const totalCount = this.extractTotalCount(response, list.length);
        return { list, totalCount };
      } catch (error) {
        console.error("Failed to load ESL tags", error);
        return { list: [], totalCount: 0 };
      }
    },
    buildQueryParameters() {
      const rawParams = {
        ...(this.queryParams || {}),
      };
      const keyword = (this.searchText || "").trim();
      if (keyword) {
        rawParams.keyword = keyword; // Backend may use this for fuzzy search; safe to ignore otherwise.
      } else {
        delete rawParams.keyword;
      }
      return Object.keys(rawParams).reduce((acc, key) => {
        const value = rawParams[key];
        if (value !== undefined && value !== null && value !== "") {
          acc[key] = value;
        }
        return acc;
      }, {});
    },
    syncQueryParameters() {
      if (!this.tableCtrl) {
        return;
      }
      this.tableCtrl.setQueryParameters(this.buildQueryParameters());
    },
    extractEslList(response) {
      if (Array.isArray(response)) {
        return response;
      }
      if (Array.isArray(response?.list)) {
        return response.list;
      }
      if (Array.isArray(response?.data?.list)) {
        return response.data.list;
      }
      return [];
    },
    extractTotalCount(response, fallbackLength = 0) {
      if (typeof response?.totalCount === "number") {
        return response.totalCount;
      }
      if (typeof response?.total === "number") {
        return response.total;
      }
      if (typeof response?.data?.totalCount === "number") {
        return response.data.totalCount;
      }
      if (typeof response?.data?.total === "number") {
        return response.data.total;
      }
      return fallbackLength;
    },
    reloadDisplays() {
      if (this.tableCtrl) {
        this.tableCtrl.loadTableData();
      }
    },
    applySearchFilter(list = []) {
      const search = (this.searchText || "").trim().toLowerCase();
      if (!search) {
        return list;
      }
      return list.filter((item = {}) => {
        const fields = [
          item.esl_code,
          item.product_code,
          item.esltype_code,
          item.ap_code,
          item.esltemplate_id,
        ];
        return fields.some((value) =>
          String(value ?? "")
            .toLowerCase()
            .includes(search)
        );
      });
    },
    getDisplayName(display = {}) {
      return display.product_code || display.esl_code || "Unnamed Display";
    },
    getDisplayDescription(display = {}) {
      return display.esltype_code || "Digital Display";
    },
    getSerialNumber(display = {}) {
      return display.esl_code || "--";
    },
    formatPrice(value) {
      if (value === undefined || value === null || value === "") {
        return "--";
      }
      const number = Number(value);
      if (Number.isFinite(number)) {
        return `$${number.toFixed(2)}`;
      }
      return value;
    },
    getProductPrice(display = {}) {
      const p =
        this.productsMap && display.product_code
          ? this.productsMap[String(display.product_code)]
          : null;
      const price = p.product_price;
      return this.formatPrice(price);
    },
    getProductSecondaryPrice(display = {}) {
      const p =
        this.productsMap && display.product_code
          ? this.productsMap[String(display.product_code)]
          : null;
      const price = p.product_vip_price;
      return this.formatPrice(price);
    },
    getProductUnit(display = {}) {
      return display.pu || "each";
    },
    getBatteryPercent(display = {}) {
      const battery = Number(display.esl_battery);
      if (!battery) {
        return "N/A";
      }
      if (battery <= 100) {
        return `${battery}%`;
      }
      const percent = Math.round(
        Math.min(100, Math.max(0, (battery / 3300) * 100))
      );
      return `${percent}%`;
    },
    getBatteryColor(display = {}) {
      const value = parseInt(this.getBatteryPercent(display), 10);
      if (Number.isNaN(value)) {
        return "text-muted-foreground";
      }
      if (value <= 20) return "text-red-500";
      if (value <= 50) return "text-yellow-500";
      return "text-green-500";
    },
    getSignalStrength(display = {}) {
      const rssi = Number(display.master_rssi);
      if (Number.isNaN(rssi)) {
        return "N/A";
      }
      const percent = Math.round(Math.min(100, Math.max(0, (rssi + 100) * 2)));
      return `${percent}%`;
    },
    getSignalColor(display = {}) {
      const value = parseInt(this.getSignalStrength(display), 10);
      if (Number.isNaN(value)) {
        return "text-muted-foreground";
      }
      if (value <= 20) return "text-red-500";
      if (value <= 50) return "text-yellow-500";
      return "text-green-500";
    },
    formatTimestamp(value) {
      if (!value) {
        return "--";
      }
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return value;
      }
      return date.toLocaleString();
    },
    getStatusBadge(display = {}) {
      const baseClass =
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2";
      const battery = parseInt(this.getBatteryPercent(display), 10);
      if (Number(display.online) === 1) {
        if (!Number.isNaN(battery) && battery <= 20) {
          return {
            label: "Low Battery",
            className: `${baseClass} border-border text-muted-foreground`,
          };
        }
        return {
          label: "Active",
          className: `${baseClass} border-transparent bg-primary text-primary-foreground hover:bg-primary/80`,
        };
      }
      return {
        label: "Disconnected",
        className: `${baseClass} border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80`,
      };
    },
    async handleSchedule(display) {
      this.menuOpen = false;
      await this.$loaderWindow({
        title: `Create Schedule`,
        component: () =>
          import("@/pages/digital-displays/SchduleListByProudctCode.vue"),
        width: "80%",
        height: "80%",
        showHeader: false,
        padding: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        props: { product_code: display.product_code },
      });
    },
    toggleMenu(display) {
      if (this.menuOpen && this.menuAnchor === display) {
        this.menuOpen = false;
        this.menuAnchor = null;
      } else {
        this.menuOpen = true;
        this.menuAnchor = display;
      }
    },
    async handleEditProduct(display) {
      this.menuOpen = false;
      await this.$loaderWindow({
        title: `Edit Display`,
        component: () => import("./EditProduct.vue"),
        width: "60%",
        showHeader: true,
        props: { productCode: display.product_code },
      });
    },
    async handleEditDisplay(display) {
      this.menuOpen = false;
      await this.$loaderWindow({
        title: `Edit Display`,
        component: () => import("./EditElTagBind.vue"),
        width: "400px",
        showHeader: false,
        props: { esl_code: display.esl_code },
      });
    },
    handleViewFullScreen(display) {
      window.open(`/digital-displays/full/${display.esl_code}`, "_blank");
    },
    async handleDeleteDisplay(display) {
      await this.$confirm(
        "Are you sure you want to delete this display?",
        "Delete Display",
        {
          type: "warning",
          confirmButtonText: "Delete",
          cancelButtonText: "Cancel",
        }
      );
      this.menuOpen = false;
    },
    async getDisplayImageUrl(display = {}) {
      const eslCode = display.esl_code;
      if (eslCode) {
        return await downloadFile(
          `${process.env.VUE_APP_API_URL_BASE}/fission/e-tag/eslpng/${eslCode}.png`
        );
      }
      return "/placeholder.svg?height=200&amp;width=150";
    },
    async onViewStatus(display) {
      await this.$loaderWindow({
        title: `Display Status`,
        component: () => import("./EtagStatusList.vue"),
        width: "80%",
        showHeader: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        padding: false,
        props: { etagCodes: [display.esl_code] },
      });
    },
    handleApply() {
      this.filterPanelVisible = false;
      this.reloadDisplays();
    },
  },
};
</script>

<style lang="scss" scoped>
.displays-list {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;

  h2 {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
  }
}
</style>
